"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "prelude-label"
};
const _hoisted_2 = {
    key: 1,
    class: "corporation-label"
};
const _hoisted_3 = {
    key: 2,
    class: "ceo-label"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardCorporationLogo = (0, vue_1.resolveComponent)("CardCorporationLogo");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)([_ctx.getMainClasses(), { 'is-corporation': _ctx.isCorporation() }])
    }, [
        (_ctx.isPrelude())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, "prelude"))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isCorporation())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_2, "corporation"))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isCeo())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, "CEO"))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isCorporation())
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardCorporationLogo, {
                key: 3,
                title: _ctx.title
            }, null, 8, ["title"]))
            : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                key: 4,
                class: (0, vue_1.normalizeClass)(_ctx.getClasses(_ctx.title))
            }, (0, vue_1.toDisplayString)(_ctx.getCardTitleWithoutSuffix(_ctx.title)), 3))
    ], 2));
}
